import * as React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import createStyles from '@material-ui/core/styles/createStyles'
import Typography from '@material-ui/core/Typography'
// import Stack from '@material-ui/core/Stack'
import styled from '@material-ui/core/styles/styled';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Tooltip from '@material-ui/core/Tooltip'
import ThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import holiday from '@18f/us-federal-holidays'
import {MdArrowDropDown, MdLocationOn, MdPhone} from 'react-icons/md';
import {AiFillCaretDown} from 'react-icons/ai';
import {BsClockFill} from 'react-icons/bs';
import {HiLocationMarker, HiClock} from 'react-icons/hi';
import theme from '../../themes/baseTheme'
import lightTheme from '../../themes/lightTheme'

const options = { shiftSaturdayHolidays: true, shiftSundayHolidays: true };


const useStyles = makeStyles((theme) => createStyles({
    flex: {
        display: 'flex'
    },
    tooltipPopper: {
        width: 300
    },
    tooltipPaperProps: {
        background: 'black'
    },
    container: {
        display: 'flex'
    },
    hours: {
        display: 'flex',
        // color: 'white'
    },
    day: {
        textTransform: 'capitalize',
        // color: 'white'
    },
    text: {
        color: 'white'
    },
    capitalize: {
        textTransform: 'capitalize',
    },
    iconWrapper: {
        display: 'grid',
        justifyContent: 'center',
        alignItems: 'center',
        width: 24,
        height: 24
    }
}))

function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

export default ({page}) => {
    if (page !== "mulch") return;
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const todaysDate = new Date().toISOString();
    const isHoliday = holiday.isAHoliday(new Date(), options);
    console.log("Holidays", todaysDate,  addDays(todaysDate, 4))
    console.log("Holidays", holiday.inRange(addDays(todaysDate, 5), addDays(todaysDate, 6)))
    const classes = useStyles();
    const [menuEl, setMenuEl] = React.useState(null);
    const businessInfo = {
        "mulch": {
            hours: {
                monday: {
                    display: '8AM - 5PM'
                },
                tuesday: {
                    display: '8AM - 5PM'
                },
                wednesday: {
                    display: '8AM - 5PM'
                },
                thursday: {
                    display: '8AM - 5PM'
                },
                friday: {
                    display: '8AM - 5PM'
                },
                saturday: {
                    display: '8AM - 12PM'
                },
                sunday: {
                    display: 'CLOSED'
                }
            }
        }
    }
    const today = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][new Date().getDay()];
    const Hours = () => <div>
        {Object.keys(businessInfo[page]?.hours).map(day => <Box key={day} className={classes.hours}>
            <Typography fontSize={12} style={{fontSize: 12, textDecoration: today === day ? 'underline' : 'none'}} fontWeight={today === day ? '900' : '500'} className={classes.day}>{day}</Typography>
            <Typography align="right"  style={{fontSize: 12, textDecoration: today === day ? 'underline' : 'none'}} fontWeight={today === day ? '900' : '500'} fontSize={12}>{businessInfo[page]?.hours[day].display}</Typography>
        </Box>)}
        <Typography variant="overline" fontSize={12} className={classes.day}>CLOSED ON HOLIDAYS</Typography>
    </div>;
    return (
        <ThemeProvider theme={theme}>
                <div style={{
                    maxWidth: 500,
                    zIndex: 100,
                    border: `2px solid rgb(237, 28, 36)`,
                    marginTop: theme.spacing(5),
                    background: 'rgba(0,0,0,0.3)',
                    backdropFilter: 'blur(4px)',
                    padding: theme.spacing(2),
                    boxShadow: "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"}}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography style={{fontWeight: 'bold'}} className={classes.text}>Visit Us for Pickup!</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className={`${classes.text} ${classes.capitalize}`}>
                                    <HiClock fontSize="medium" />
                                    <span>
                                        {` ${today} ${businessInfo.mulch.hours[today]?.display} `}
                                    </span>
                                    <ThemeProvider theme={lightTheme}>
                                        {!isSmall && <Tooltip
                                            placement="bottom"
                                            enterDelay={0}
                                            leaveDelay={1000}
                                            interactive
                                            disableTouchListener
                                            PopperProps={{
                                                className: classes.tooltipPopper,
                                                keepMounted: false,
                                                PaperProps: classes.tooltipPopper
                                            }}
                                            title={
                                                <React.Fragment>
                                                        <Hours />
                                                </React.Fragment>}
                                                >
                                            <IconButton size="small">
                                                <AiFillCaretDown  style={{zIndex: 101, marginTop: -2}} color="white" fontSize={12} />
                                            </IconButton>
                                        </Tooltip>}
                                        {isSmall && <IconButton size="small" onClick={e => setMenuEl(e.currentTarget)}>
                                            <AiFillCaretDown  style={{zIndex: 101, marginTop: -2}} color="white" fontSize={12} />
                                        </IconButton>}
                                        {isSmall && <Menu
                                            open={Boolean(menuEl)}
                                            anchorEl={menuEl}
                                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                                            PaperProps={{square: true, elevation: 8}}
                                            onClose={() => setMenuEl(null)}
                                        >
                                            <div style={{paddingRight: theme.spacing(), paddingLeft: theme.spacing()}}>
                                                <Hours />
                                            </div>
                                            
                                        </Menu>}
                                    </ThemeProvider>
                                </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Link style={{textDecoration: 'none'}} target="__blank" href="https://www.google.com/maps/place/1400+Cahill+Dr,+Lexington,+KY+40504/@38.0561672,-84.5332031,17z/data=!3m1!4b1!4m5!3m4!1s0x8842437a46b8164f:0x2b740d4fa88128dc!8m2!3d38.0561672!4d-84.5310144">
                                <Typography  style={{fontStyle: 'normal'}} component="address" className={`vcard ${classes.text} ${classes.capitalize}`}>
                                    <HiLocationMarker fontSize="medium" />
                                    {' '}
                                    <span className="adr" >
                                        <Typography component='span' className="street-address">1400 Cahill Dr.</Typography>
                                        {' '}
                                        <Typography component='span' className="locality">Lexington</Typography>,
                                        {' '}
                                        <Typography component='span' className="region" title="Kentucky">KY</Typography>
                                        {' '}
                                        <Typography component='span' className="postal-code">40504</Typography>
                                    </span>
                                </Typography>
                            </Link>
                            
                        </Grid>
                        <Grid item xs={12}>
                        <Link style={{textDecoration: 'none'}} href="tel:+18592550077">
                            <Typography className={`${classes.text} ${classes.capitalize}`}>
                                <MdPhone fontSize="medium" />
                                {' '}
                                859-223-3051
                            </Typography>
                        </Link>
                        </Grid>
                    </Grid>
                </div>
        </ThemeProvider>
    );
}